module.exports = __webpack_public_path__ + "img/grape1.cd1f150d.jpg";